var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "column-12 laptop:column-2 order-last laptop:order-first tablet:display-flex laptop:display-block",
    },
    [
      _c(
        "div",
        {
          staticClass: "tablet:margin-top-3xl",
          staticStyle: { flex: "1 0 0" },
        },
        [
          _c("font-awesome-icon", {
            staticClass: "decorative",
            staticStyle: { color: "var(--fa-md-gravy)" },
            attrs: { icon: _vm.$v6.solid.faCircleQuestion, size: "xl" },
          }),
          _vm._v(" "),
          _c("h4", { staticClass: "margin-top-md margin-bottom-2xs" }, [
            _vm._v("Support"),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Have a question about our plans?")]),
          _vm._v(" "),
          _c("p", [
            _c(
              "a",
              {
                attrs: {
                  href: "mailto:hello@fontawesome.com?subject=I've got a question about plans, Font Awesome!",
                },
                on: {
                  click: function ($event) {
                    return _vm.supportLinkClicked("plans_view", "card_section")
                  },
                },
              },
              [_vm._v("Get in touch!")]
            ),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "margin-top-3xl", staticStyle: { flex: "1 0 0" } },
        [
          _c("font-awesome-icon", {
            staticClass: "decorative",
            staticStyle: { color: "var(--fa-md-gravy)" },
            attrs: { icon: _vm.$v6.solid.faRocketLaunch, size: "xl" },
          }),
          _vm._v(" "),
          _c("h4", { staticClass: "margin-top-md margin-bottom-2xs" }, [
            _vm._v("Start for Free"),
          ]),
          _vm._v(" "),
          _c("p", [_vm._v("Want to give Font Awesome a try?")]),
          _vm._v(" "),
          _c(
            "p",
            [
              _c("site-link", { attrs: { to: { name: "start" } } }, [
                _vm._v("Grab a Free account!"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }